/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const MultiIconFragment = {
  MultiIcon: gql`
    fragment MultiIconQuery on multiIcon_Entry {
      iconList {
        ... on iconListBlock_Entry {
          iconImage {
            url
            ... on images_Asset {
              altText
            }
          }
        }
      }
      componentTitle
      lineBreak_mainContent
      lineBreak_styles
      styles
      typeHandle
    }
  `,
};
